import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseClientEquipmentUsageDeclarationsHistory<T> = {
  equipmentId?: string;
  filters?: {
    search?: string;
    page?: number;
    createdAtStartDate?: string;
    createdAtEndDate?: string;
    productId?: string;
    productCategoryId?: string;
  }
  mapper?: (data: any) => T
}

export const useClientEquipmentUsageDeclarationsHistory = <T,>({
  equipmentId,
  filters: { search = '', page = 1, createdAtStartDate, createdAtEndDate, productId, productCategoryId } = {},
  mapper = Mapper.default<T>(),
}: UseClientEquipmentUsageDeclarationsHistory<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['clientEquipmentUsageDeclarationsHistory', equipmentId, search, page, createdAtStartDate, createdAtEndDate, productId, productCategoryId],
    queryFn: () => {
      return privateAxios.get(`/client/equipments/${equipmentId}/usage_declarations`, {
        params: {
          search,
          page,
          'q[created_at_gteq]': createdAtStartDate,
          'q[created_at_lteq]': createdAtEndDate,
          'q[product_id_eq]': productId,
          'q[product_category_id_eq]': productCategoryId
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest }
}
